// Shared constants, API helpers and React Context for the /inventory
// tracker. Split out of the monolithic InventoryPreview.jsx so each
// section-component can import only what it needs.

import { createContext, useContext } from "react";

export const NAVY  = "#0F2857";
export const TEAL  = "#2A9F92";
export const MIST  = "#F0F5F4";
export const AMBER = "#F59E0B";

export const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

// React Context — populated by <InvCtx.Provider value={useInventoryStore()}>.
// Every child component reads its slice via `useInv()`.
export const InvCtx = createContext(null);
export const useInv = () => useContext(InvCtx) || {};

// ─── low-level fetch helpers (throw on non-2xx, unwrap FastAPI's
//     validation-error shape so callers get a plain string message)

export async function inv_get(path) {
  const r = await fetch(`${API}/inventory${path}`);
  if (!r.ok) throw new Error(`GET ${path} ${r.status}`);
  return r.json();
}

export async function inv_post(path, body, token) {
  const r = await fetch(`${API}/inventory${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "X-Auth-Token": token } : {}),
    },
    body: JSON.stringify(body ?? {}),
  });
  if (!r.ok) {
    const raw = await r.text();
    let msg = "";
    try {
      const j = JSON.parse(raw);
      msg = typeof j?.detail === "string" ? j.detail : (j?.detail?.[0]?.msg || "");
    } catch (_) { /* not JSON — fall through */ }
    throw new Error(msg || raw || `POST ${path} ${r.status}`);
  }
  return r.json();
}
